<template>
  <div>
    <v-dialog
      v-model="isDialog"
      max-width="400"
      @keydown.esc="$emit('input', false)"
      @click:outside="$emit('input', false)"
    >
      <v-card>
        <v-tooltip top v-if="type == 'add' && currentProject && currentProject.areaLimit !== undefined">
          <template v-slot:activator="{ on, attrs }">
            <v-progress-linear
              v-bind="attrs"
              v-on="on"
              :value='percentageArea'
              :color="`${percentageArea >= 100 ? 'error' : 'info'}`"
              rounded
              absolute
              top>
            </v-progress-linear>
          </template>
          <div>{{ $t('area.number_of_market_area_in_project', { get: $helper.toArabic(getProjectAreaCount || 0), max: $helper.toArabic(currentProject.areaLimit || 0) }) }}</div>
        </v-tooltip>
        <v-card-title>
          <template v-if="type == 'edit'">
            <v-icon left>mdi-pencil</v-icon> {{ $t('area.edit_market_area') }}
          </template>
          <template v-else>
            <v-icon left>mdi-plus-box-multiple-outline</v-icon> {{ $t('area.add_market_area') }}
          </template>
        </v-card-title>
        <v-card-text>
          <h2 v-if="market">{{ market.name }}</h2>
          <p class="mb-1">{{ $t('area.market_area_name_and_area_number') }}</p>
          <v-text-field
            flat
            solo
            background-color="grey lighten-3"
            name="name"
            :label="$t('input_data')"
            class="mb-4"
            :placeholder="$t('input_data')"
            v-model="form.name"
            :rules="[
              v => !!v || `${$t('insert_data')}`, 
            ]"
            hide-details>
          </v-text-field>
          <p class="mb-1">{{ $t('area.size_square_meter') }}</p>
          <v-currency-field
            flat
            solo
            background-color="grey lighten-3"
            :label="$t('input_data')"
            :placeholder="$t('input_data')"
            v-model="form.size" 
            :rules="[
              v => !!v || `${$t('insert_data')}`, 
              //v => v > 0 || `${$t('validate.please_input_greater_than_zero')}`, 
            ]"
            hide-details>
          </v-currency-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isLoading"
            color="error"
            elevation="0"
            @click.native="$emit('input', false)"
          >{{ $t('cancel') }}
          </v-btn>
          <v-btn
            v-if="type == 'edit'"
            :loading="isLoading"
            color="primary"
            elevation="0"
            @click="updateArea"
            :disabled="!form.name || form.size == null || form.size == undefined || form.size < 0 ? true : false || isLoading"
          >{{ $t('save') }}
          </v-btn>
          <v-btn
            v-else
            :loading="isLoading"
            color="primary"
            elevation="0"
            @click="createArea"
            :disabled="!form.name || form.size == null || form.size == undefined || form.size < 0 ? true : false || isLoading"
          >{{ $t('add_data') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model='isErrorAreaLimit' max-width="500" persistent>
      <v-card>
        <v-card-title>
          {{ $t('area.cannot_add_market_area') }}
        </v-card-title>
        <v-card-text class="text-center">
          <h3 class="">{{ $t('area.full_market_area') }}</h3>
          <div class="mt-2" v-if="currentProject">{{ $t('area.project_can_create_market_area', { name: currentProject.name, count: currentProject.areaLimit }) }}</div>
          <div class="my-1">{{ $t('area.want_to_add_market_area') }}</div>
          <a class="info--text text-decoration-underline" href="https://www.myket.in.th/#contract"
            target="_blank">{{ $t('customer.contact_myket_team') }}</a>
        </v-card-text>
        <v-card-actions class="mb-2">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="closingDialog()">{{ $t('acknowledge') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: {
    value: Boolean,
    market: Object,
    project: Object,
    area: Object,
    type: String,
  },
  computed: {
    ...mapGetters({
      areas: "area/getAreas",
      getProjectAreaCount: "area/projectAreaCount",
      adminGetByMarketId: "admin/getByMarketId",
      employeeGetByMarketId: "employee/getByMarketId",
    }),
    percentageArea() {
      return (this.getProjectAreaCount / (this.currentProject?.areaLimit || 0)) * 100;
    },
    currentProject() {
      let p
      if (this.project)
        p = this.project
      else if (this.market?.objectId) {
        let admin = this.adminGetByMarketId(this.market.objectId)
        let employee = this.adminGetByMarketId(this.market.objectId)
        p = admin ? admin.project : employee ? employee.project : null
      }
      return p
    },
    isDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  created() {
    if (this.type == 'add') 
      this.projectAreaCount({ projectId: this.projectId })
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      isErrorAreaLimit: false,
      isLoading: false,
      form: {
        name: "",
        size: "",
      },
    };
  },
  watch: {
    value() {
      if (this.area) {
        this.form = {
          id: this.area.objectId,
          name: this.area.name,
          size: this.area.size
        }
        this.form.size = this.area.size ? parseFloat(String(this.area.size).replace(/,/g, '')) : 0
      } else {
        this.form = {
          name: null,
          size: null
        }
      }
    }
  },
  methods: {
    ...mapActions({
      projectAreaCount: "area/projectAreaCount"
    }),
    async createArea() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("area/createArea", {
          name: this.form.name,
          size: this.form.size,
          marketId: this.market.objectId,
        })
        this.isLoading = false
        this.$emit("input", false)
        this.$emit("onSuccess", true)
      } catch (error) {
        console.log({ error })
        this.isLoading = false;
        if (error?.response?.data?.error?.errorCode == 'limited')
          this.isErrorAreaLimit = true;
        else if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    async updateArea() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("area/updateArea", {
          id: this.form.id,
          name: this.form.name,
          size: this.form.size,
          marketId: this.market.objectId,
        })
        this.isLoading = false
        this.$emit("input", false)
        this.$emit("onSuccess", true)
      } catch (error) {
        this.isLoading = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },
    closingDialog() {
      this.isErrorAreaLimit = false;
      this.isDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
